<template>
  <b-container>
    <h1 v-translate>Edit Warehouse</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <translate>The Item has been updated</translate>
    </b-alert>
    <location-form :location="location" type="warehouses" @success="showAlert" />
  </b-container>
</template>

<script>
import LocationForm from '@/components/LocationForm'

export default {
  name: 'NewWarehouse',
  components: {
    LocationForm
  },
  data() {
    return {
      location: {},
      success: false,
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  mounted() {
    this.fetchWarehouse()
  },
  methods: {
    fetchWarehouse() {
      this.$http.get(this.$appConfig.api.baseUrl + 'warehouses/' + this.$route.params.id)
        .then(response => {
          this.location = response.body
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
